import { useEffect, useMemo, useState } from 'react'
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { sanitizeHtml, toEmailHtml } from './emailHtml'


export default function HtmlDialog({ open, onClose, onInsert }) {
  const { t } = useTranslation()
  const [source, setSource] = useState('')

  useEffect(() => {
    if (open) setSource('')
  }, [open])

  const preview = useMemo(() => (source.trim() ? toEmailHtml(source) : ''), [source])

  const stripped = useMemo(() => {
    if (!source.trim()) return []

    const tags = [...source.matchAll(/<\s*([a-zA-Z][a-zA-Z0-9]*)\b/g)].map(match => match[1].toLowerCase())
    const kept = sanitizeHtml(source).toLowerCase()

    return [...new Set(tags)].filter(tag => !kept.includes(`<${tag}`))
  }, [source])

  const insert = () => {
    onInsert(preview)
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>{t('Insert HTML')}</DialogTitle>
      <DialogContent dividers>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="caption" color="text.secondary">
              {t('Source')}
            </Typography>
            <TextField
              fullWidth
              multiline
              minRows={16}
              value={source}
              onChange={event => setSource(event.target.value)}
              placeholder="<p>Hello <strong>{{firstName}}</strong></p>"
              InputProps={{ sx: { fontFamily: 'monospace', fontSize: 13, alignItems: 'flex-start' } }}
            />
          </Box>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="caption" color="text.secondary">
              {t('Preview')}
            </Typography>
            <Box
              sx={{
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                p: 2,
                minHeight: 380,
                overflow: 'auto',
                bgcolor: '#ffffff',
                color: '#222222',
              }}
              dangerouslySetInnerHTML={{ __html: preview }}
            />
          </Box>
        </Stack>

        {stripped.length > 0 && (
          <Alert severity="warning" sx={{ mt: 2 }}>
            {t('Removed tags email clients will not render: {{tags}}', { tags: stripped.join(', ') })}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('Cancel')}</Button>
        <Button variant="contained" disabled={!preview} onClick={insert}>
          {t('Insert')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
